module.exports = __webpack_public_path__ + "img/img_baby_app_3_ko.32102753.png";